(function() {
    'use strict';

    angular.module('news.constants', [])
        .constant('newsMessagesConst', {
            add: 'Dodano nową aktualność!',
            update: 'Dane aktualności zostały zaktualizowane!',
            delete: 'Aktualność została usunięta!',
            error: 'Wystąpił bład!'
        })
        .constant('newsPermissionsConst', {
            view: {
                value: 'view_news',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu aktualności!'
            },
            add: {
                value: 'add_news',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania aktualności!'
            },
            update: {
                value: 'change_news',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji aktualności!'
            },
            delete: {
                value: 'delete_news',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania aktualności!'
            }
        });
})();
